import { InputProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DateTimePicker as _DateTimePicker } from '@mui/x-date-pickers';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {formatDateTimeParam, toDateTimeParam} from "../../../../utils/formatDate.ts";
import {getValueFromNestedObject} from "../../../../utils/langUtils.ts";
import { t } from "@lingui/core/macro";

const DateTimePicker = styled(_DateTimePicker)`
    padding: 0.4rem 0.7rem;
`;

type FormDateTimeProps = {
    name: string;
    label: string;
    onChange?: (date: Date | null) => void;
} & InputProps;

const FormDateTime: FC<FormDateTimeProps> = ({ name, label, ...otherProps }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const error = getValueFromNestedObject(errors, name)

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <DateTimePicker
                    // @ts-expect-error avoid non assignable type
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            margin: 'normal',
                            fullWidth: true,
                        },
                        field: { clearable: true }
                    }}
                    // @ts-ignore
                    value={field.value && toDateTimeParam(field.value) }
                    inputRef={field.ref}
                    onChange={(date: Date | null) => {
                        if (date) {
                            field.onChange(formatDateTimeParam(date));
                        } else {
                            field.onChange(undefined);
                        }
                        if (otherProps.onChange) {
                            otherProps.onChange(date);
                        }
                    }}
                    error={!!error}
                    label={label}
                    margin="normal"
                    calendarStartDay={2}
                    ampm={false}
                    helperText={
                        error ? (error?.message as unknown as string) : ''
                    }
                    localeText={ {
                        okButtonLabel: t`OK`,
                        cancelButtonLabel: t`Cancel`,
                    } }
                    {...otherProps}
                />
            )}
        />
    );
};

export default FormDateTime;
